<template>
  <b-container class="h-100">
    <transition name="slide-fade">
      <b-row class="h-100">
        <b-col
          class="d-flex flex-column justify-content-center login-wrapper--right-form"
        >
          <div class="d-flex">
            <b-img src="/img/logo.svg" fluid />
          </div>

          <div class="mt-4">
            <h3 class="font-weight-bold">Send Reset Code</h3>
            <p class="mt-3">
              Enter code sent to: <br />
              <shimmer v-if="loading" height="20px" width="40%"></shimmer>
              <b v-else>{{ verifiedAccount }}</b>
            </p>
          </div>

          <b-form @submit.prevent="onSubmit">
            <b-form-group id="input-group-2" class="col-12">
              <label class="font-weight-bold">Reset Code</label>

              <b-form-input
                id="input-2"
                v-model="form.token"
                class="form-control effect-26"
                :class="form.token ? 'has-content' : ''"
                type="text"
                required
                autofocus
                placeholder="Enter reset code"
              ></b-form-input>
            </b-form-group>
            <div class="input-error" v-if="form.$getError('token')">
              {{ form.$getError('token')[0] }}
            </div>

            <b-form-group id="input-group-3" class="col-12">
              <label class="font-weight-bold">Password</label>

              <b-form-input
                id="input-3"
                v-model="form.password"
                class="form-control effect-26"
                :class="form.password ? 'has-content' : ''"
                type="password"
                autocomplete="new-password"
                required
                placeholder="Enter new password"
              ></b-form-input>
            </b-form-group>
            <div class="input-error" v-if="form.$getError('password')">
              {{ form.$getError('password')[0] }}
            </div>

            <b-form-group id="input-group-4" class="col-12">
              <label class="font-weight-bold">Confirm Password</label>

              <b-form-input
                id="input-4"
                v-model="form.password_confirmation"
                class="effect-26"
                :class="form.password_confirmation ? 'has-content' : ''"
                type="password"
                autocomplete="new-password"
                required
                placeholder="Enter password confirmation"
              ></b-form-input>
            </b-form-group>
            <div
              class="input-error"
              v-if="form.$getError('password_confirmation')"
            >
              {{ form.$getError('password_confirmation')[0] }}
            </div>

            <div class="ta-right mt-4">
              <b-button
                class="form-button full-width"
                type="submit"
                variant="primary"
              >
                <b-spinner small v-if="form.$busy"></b-spinner>
                <div v-else>SUBMIT</div>
              </b-button>
            </div>

            <div class="ta-center mt-4">
              <b-link class="form-link" @click.prevent="onResendCode"
                >Didn't receive a code?</b-link
              >
            </div>
          </b-form>
        </b-col>
      </b-row>
    </transition>
  </b-container>
</template>

<script>
import Form from '@/utils/form'
import shimmer from '@/components/shimmers/shimmer'

export default {
  components: {
    shimmer
  },
  data() {
    return {
      loading: false,
      verifiedAccount: '',
      form: new Form({
        email: '',
        token: '',
        password: '',
        password_confirmation: ''
      })
    }
  },

  methods: {
    async onSubmit(evt) {
      this.form.$busy = false
      await this.$api
        .post('auth/reset-password', {
          username: this.form.email,
          token: this.form.token,
          password: this.form.password,
          password_confirmation: this.form.password_confirmation
        })
        .then(({ data }) => {
          this.form.$busy = false
          this.$router.replace({ name: 'auth.login-page' })
        })
        .catch(error => {
          this.form.$handleError(error)
        })
    },
    async onResendCode(evt) {
      this.form.$busy = true
      await this.$api
        .post('auth/forgot-password', {
          username: this.form.email
        })
        .then(({ data }) => {
          this.form.$busy = false
        })
        .catch(error => {
          this.form.$handleError(error)
        })
    },
    async getVerifiedAccount() {
      this.loading = true
      await this.$api
        .post('auth/reset-password/get-verified-account', {
          email: this.$route.params.email
        })
        .then(({ data }) => {
          this.verifiedAccount = data.verified_account
          this.loading = false
        })
    }
  },

  created() {
    this.form.email = this.$route.params.email
    this.getVerifiedAccount()
  },

  watch: {
    'form.token'() {
      this.form.$clearError('token')
    },
    'form.password'() {
      this.form.$clearError('password')
    }
  }
}
</script>
